export default "__VITE_ASSET__f33e46a5__"